const modules = import.meta.glob(['./*.js', '!./index.js'], { eager: true });

const releases = Object.values(modules)
  .flatMap(m => m.default)
  .sort((a, b) => {
    const [aMajor, aMinor] = a.release.split('.').map(Number);
    const [bMajor, bMinor] = b.release.split('.').map(Number);

    return bMajor - aMajor || bMinor - aMinor;
  });

export default releases;
